var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.15625,
    width: 25,
    height: 25,
    rx: 3,
    fill: "#55BAF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85091 17.3333H17.0176C17.1723 17.3333 17.3207 17.3904 17.4301 17.492C17.5395 17.5936 17.6009 17.7314 17.6009 17.875C17.6009 18.0187 17.5395 18.1564 17.4301 18.258C17.3207 18.3596 17.1723 18.4167 17.0176 18.4167H8.85091C8.6962 18.4167 8.54783 18.3596 8.43843 18.258C8.32904 18.1564 8.26758 18.0187 8.26758 17.875C8.26758 17.7314 8.32904 17.5936 8.43843 17.492C8.54783 17.3904 8.6962 17.3333 8.85091 17.3333ZM8.26758 14.625L14.1009 9.20834L15.8509 10.8333L10.0176 16.25H8.26758V14.625ZM14.6842 8.66668L15.8509 7.58334L17.6009 9.20834L16.4337 10.2922L14.6842 8.66668Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon2);
export default __webpack_public_path__ + "static/media/edit_icon_2.996dca0f2359913d8f1acac74cd2a470.svg";
export { ForwardRef as ReactComponent };